import { Routes } from '@angular/router';
import { authGuard, projectGuard } from './guards/auth.guard';
import { ResumoRestricaoResolver } from './external/resumo-restricao/resumo-restricao.resolver';

export const routes: Routes = [
  { path: '', redirectTo: '/autenticacao/login', pathMatch: 'full' },
  {
    path: 'autenticacao/login',
    loadComponent: () => import('./external/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'external/resumo-restricao/:token/:projectId/:restrictionId',
    loadComponent: () => import('./external/resumo-restricao/resumo-restricao.component').then(m => m.ResumoRestricaoComponent),
    resolve: { summary: ResumoRestricaoResolver }
  },
  {
    path: 'home',
    loadComponent: () => import('./internal/home/home.component').then(m => m.HomeComponent),
    canActivate: [authGuard]
  },
  {
    path: 'home/gestao-projeto',
    loadComponent: () => import('./shared/components/project-layout/project-layout.component').then(m => m.ProjectLayoutComponent),
    canActivate: [projectGuard],
    data: { skipChildHistory: true },
    children: [
      { path: '', redirectTo: 'project-info', pathMatch: 'full' },
      {
        path: 'project-info',
        loadComponent: () => import('./internal/project-info/project-info.component').then(m => m.ProjectInfoComponent)
      },
    ]
  },
  {
    path: 'home/gestao-ativos',
    loadComponent: () => import('./shared/components/project-layout/project-layout.component').then(m => m.ProjectLayoutComponent),
    canActivate: [projectGuard],
    data: { skipChildHistory: true },
    children: [
      { path: '', redirectTo: 'restricoes', pathMatch: 'full' },
      {
        path: 'restricoes',
        loadComponent: () => import('./internal/gestao-ativo/restrictions/restrictions.component').then(m => m.RestrictionsComponent)
      },
      {
        path: 'data-model',
        loadComponent: () => import('./internal/gestao-ativo/data-model/data-model.component').then(m => m.DataModelComponent)
      },
      {
        path: 'kpis',
        loadComponent: () => import('./internal/gestao-ativo/kpis/kpis.component').then(m => m.KpisComponent)
      }
    ]
  },
  // Rota curinga para redirecionar rotas não encontradas para a página de login
  {
    path: '**', redirectTo: '/autenticacao/login'
  },
];
